Namespace 'Monitoring.Views'

class Monitoring.Views.SocialContentActionsEditView extends Backbone.View
  template: JST["backbone/templates/monitoring/rules/social_content_actions_edit"]

  className: 'social-content-actions'

  events:
    'change #selected-social-content-tag':                  'onChangeSelectedSocialContentTag'
    'change #selected-social-content-tag-to-remove':        'onChangeSelectedSocialContentTagToRemove'
    'change #remove-all-social-content-tags':               'onRemoveAllTagsFromSocialContent'
    'change #selected-social-content-label':                'onChangeSelectedSocialContentLabel'
    'change #inherit-group-from-parent':                    'onChangeInheritGroupFromParent'
    'change #selected-social-content-label-to-remove':      'onChangeSelectedSocialContentLabelToRemove'
    'change #selected-social-content-sentiment':            'onChangeSelectedSocialContentSentiment'
    'change #selected-social-content-moderation-decision':  'onChangeSelectedSocialContentModerationDecision'

  initialize: (@options = {}) ->
    @addTagToSocialContentAction = @defineValue(@options.addTagToSocialContentAction, 'add_tag_to_social_content')
    @removeTagFromSocialContentAction = @defineValue(@options.removeTagFromSocialContentAction, 'remove_tag_from_social_content')
    @removeAllTagsFromSocialContentAction = @defineValue(@options.removeAllTagsFromSocialContentAction, 'remove_all_tags_from_social_content')
    @addLabelToSocialContentAction = @defineValue(@options.addLabelToSocialContentAction, 'add_label_to_social_content')
    @inheritGroupFromParent = @defineValue(@options.inheritGroupFromParent, 'inherit_group_from_parent')
    @removeLabelfromSocialContentAction = @defineValue(@options.removeLabelfromSocialContentAction, 'remove_label_from_social_content')
    @addSentimentToSocialContentAction =  @defineValue(@options.addSentimentToSocialContentAction, 'add_sentiment_to_social_content')
    @addModerationDecisionToSocialContentAction =  @defineValue(@options.addModerationDecisionToSocialContentAction, 'add_moderation_decision_to_social_content')
    @availableTags = @options.availableTags
    @availableGroups = @options.availableGroups
    @availableSentiments = _.filter(@options.availableSentiments, (sentiment) => sentiment.code != 'missing')
    @availableModerationDecision = @options.availableModerationDecision

  render: =>
    @$el.html(@template(@))
    @

  getActions: ->
    [
      @addTagToSocialContentAction,
      @removeTagFromSocialContentAction,
      @removeAllTagsFromSocialContentAction,
      @addLabelToSocialContentAction,
      @inheritGroupFromParent,
      @removeLabelfromSocialContentAction,
      @addSentimentToSocialContentAction,
      @addModerationDecisionToSocialContentAction
    ]

  onChangeSelectedSocialContentTag: (evt) =>
    selectedSocialContentTagId = $(evt.currentTarget).find('option:selected').val();
    @addTagToSocialContentAction = @defineValue(selectedSocialContentTagId, 'add_tag_to_social_content')
    @trigger('changed-mandatory-field')

  onChangeSelectedSocialContentTagToRemove: (evt) =>
    selectedSocialContentTagId = $(evt.currentTarget).find('option:selected').val();
    @removeTagFromSocialContentAction = @defineValue(selectedSocialContentTagId, 'remove_tag_from_social_content')
    @trigger('changed-mandatory-field')

  onRemoveAllTagsFromSocialContent: (evt) =>
    removeAllTagsFromSocialContentValue = evt.currentTarget.checked
    @removeAllTagsFromSocialContentAction = @defineValue(removeAllTagsFromSocialContentValue, 'remove_all_tags_from_social_content')
    if removeAllTagsFromSocialContentValue
      @removeTagFromSocialContentAction = @defineValue('', 'remove_tag_from_social_content')
      @addTagToSocialContentAction = @defineValue('', 'add_tag_to_social_content')

    removeTagSelect = @$el.find('#selected-social-content-tag-to-remove')
    removeTagSelect.val('')
    removeTagSelect.prop('disabled', removeAllTagsFromSocialContentValue).trigger('chosen:updated')

    addTagSelect = @$el.find('#selected-social-content-tag')
    addTagSelect.val('')
    addTagSelect.prop('disabled', removeAllTagsFromSocialContentValue).trigger('chosen:updated')

    @trigger('changed-mandatory-field')

  onChangeSelectedSocialContentLabel: (evt) =>
    selectedSocialContentLabelId = $(evt.currentTarget).find('option:selected').val();
    @addLabelToSocialContentAction = @defineValue(selectedSocialContentLabelId, 'add_label_to_social_content')
    if !selectedSocialContentLabelId
      @$el.find('#inherit-group-from-parent').prop('checked', false)
      @inheritGroupFromParent = @defineValue(false, 'inherit_group_from_parent')
    @$el.find('#inherit-group-from-parent').prop('disabled', selectedSocialContentLabelId == '')
    @trigger('changed-mandatory-field')

  onChangeInheritGroupFromParent: (evt) =>
    inheritGroupFromParentValue = evt.currentTarget.checked
    @inheritGroupFromParent = @defineValue(inheritGroupFromParentValue, 'inherit_group_from_parent')

  onChangeSelectedSocialContentLabelToRemove: (evt) =>
    selectedSocialContentLabelId = $(evt.currentTarget).find('option:selected').val();
    @removeLabelfromSocialContentAction = @defineValue(selectedSocialContentLabelId, 'remove_label_from_social_content')
    @trigger('changed-mandatory-field')

  onChangeSelectedSocialContentSentiment: (evt) =>
    selectedSocialContentSentiment = $(evt.currentTarget).find('option:selected').val();
    @addSentimentToSocialContentAction = @defineValue(selectedSocialContentSentiment, 'add_sentiment_to_social_content')
    @trigger('changed-mandatory-field')

  onChangeSelectedSocialContentModerationDecision: (evt) =>
    selectedSocialContentModerationDecision = $(evt.currentTarget).find('option:selected').val();
    @addModerationDecisionToSocialContentAction = @defineValue(selectedSocialContentModerationDecision, 'add_moderation_decision_to_social_content')
    @trigger('changed-mandatory-field')

  defineValue: (new_value, value_type) ->
    if new_value == undefined || new_value == ''
      ''
    else
      {
        type: value_type,
        name: new_value
      }

  removeAllTagsFromSocialContent: =>
    (@removeAllTagsFromSocialContentAction != '') and @removeAllTagsFromSocialContentAction.name

  allMandatoryFieldsAreFilled: =>
    (@addTagToSocialContentAction!= undefined && !_.isEmpty(@addTagToSocialContentAction)) ||
    (
      @removeAllTagsFromSocialContent() ||
      @removeTagFromSocialContentAction!= undefined && !_.isEmpty(@removeTagFromSocialContentAction)
    ) ||
    (@addLabelToSocialContentAction!= undefined && !_.isEmpty(@addLabelToSocialContentAction)) ||
    (@removeLabelfromSocialContentAction!= undefined && !_.isEmpty(@removeLabelfromSocialContentAction)) ||
    (@addSentimentToSocialContentAction!= undefined && !_.isEmpty(@addSentimentToSocialContentAction)) ||
    (@addModerationDecisionToSocialContentAction!= undefined && !_.isEmpty(@addModerationDecisionToSocialContentAction))
